import { AsyncButton } from "aic";
import { HierarchyBrowserContextProvider } from "components/hierarchybrowser/HierarchyBrowserContextProvider";
import { ReactNode } from "react";
import { Container, Modal } from "react-bootstrap";
import { HierarchyBrowser } from "../hierarchybrowser/HierarchyBrowser";
import { CopyReportModalName } from "./CopyReportModalName";
import { CopyReportModalOk } from "./CopyReportModalOk";

export interface CopyReportModalProps {
  show: boolean;
  onClose: () => void;
}

/**
 * Modal to copy an existing report to a new study/report name.
 *
 * @param props - Destructured parameter object
 * @param props.show - Controls modal visibility.
 * @param props.onClose - Callback invoked when the modal should close.
 */
export const CopyReportModal = ({ show, onClose: onCancel }: CopyReportModalProps): ReactNode => {
  /**
   * Handles modal close action.
   */
  const cx = () => onCancel();

  return (
    <Modal
      show={show}
      onHide={cx}
      size="xl"
      fullscreen="xl-down"
    >
      <HierarchyBrowserContextProvider>
        <Modal.Header closeButton>
          <Modal.Title>
            <Container>Copy report</Container>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <HierarchyBrowser heightPx={450} />
            <CopyReportModalName />
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <AsyncButton
            id="copyreportmodal-cancel"
            variant="secondary"
            onClick={cx}
          >
            Cancel
          </AsyncButton>
          <CopyReportModalOk onClick={cx} />
        </Modal.Footer>
      </HierarchyBrowserContextProvider>
    </Modal>
  );
};

CopyReportModal.displayName = "CopyReportModal";
